import Vue from 'vue';
import {
  MODAL_UPDATE,
  MODAL_CLOSE_ALL,
  API_ERROR_SET,
} from './types';

export default {
  /**
   * Sets display data for cart
   * @param state
   * @param {String} name - name of modal.
   * @param {String|Boolean|Array|Object} data - name of modal.
   */
  [MODAL_UPDATE]: (state, { name, data }) => {
    if (!(name in state.modals)) {
      console.error(`Modal window with name ${name} not described in store!`);
    }
    Vue.set(state.modals, name, data);
  },

  /**
   * Close all modals]
   */
  [MODAL_CLOSE_ALL]: (state) => {
    Object.keys(state.modals).forEach((modalName) => {
      Vue.set(state.modals, modalName, null);
    });
  },

  /**
   * Set api error
   *
   * @prop {String} detail - name of modal
   * @prop {String|Boolean|Array|Object} data - error data
   */
  [API_ERROR_SET]: (state, { data = {}, detail, originError }) => {
    Vue.set(state, 'apiError', { data, detail });

    if (originError) {
      console.error(originError);
    }
  },
};



// WEBPACK FOOTER //
// ./src/apps/core/store/mutations.js